import Button from '@dc/ui-library/src/molecules/Button/Button';
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  resetAllFilters,
  resetFilterOptions
} from '../../../../../appState/ducks/listingPageFilters';
import { fetchListingPageData } from '../../../../../appState/ducks/network';
import { toggleXhrErrorWarning } from '../../../../../appState/ducks/listingPageSetup';
import { filterTypes, isFilterActive } from './filterHelpers';

class FiltersMobileButtons extends PureComponent {
  constructor(props) {
    super(props);
    this.bottomButtonsRef = React.createRef();
    this.state = {
      isSticky: true
    };

    this.onResetButtonClick = this.onResetButtonClick.bind(this);
    this.onSubmitButtonClick = this.onSubmitButtonClick.bind(this);
  }

  componentDidMount() {
    const bottomButtonsRect = this.bottomButtonsRef.current.getBoundingClientRect();
    const screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    if ((bottomButtonsRect.height + bottomButtonsRect.top) < screenHeight) {
      // intentional re-render here
      this.setState({ // eslint-disable-line
        isSticky: false
      });
      this.forceUpdate();
    }
  }

  onResetButtonClick() {
    if (this.props.selectedFilter === null) {
      this.props.resetAllFilters();
    } else {
      this.props.resetFilterOptions({
        filterName: this.props.selectedFilter,
        clearBetweenValues: this.props.selectedFilter === filterTypes.price,
        fetchNewData: true
      });
    }
  }

  onSubmitButtonClick() {
    if (this.props.selectedFilter === null) {
      this.props.hideContainer();
      this.props.toggleXhrErrorWarning(false);
    } else {
      const whatChanged = 'filters';
      this.props.fetchListingPageData(whatChanged).then(() => {
        this.props.setSelectedFilter(null);
      });
      this.props.toggleXhrErrorWarning(!this.props.productsPostXhrError);
    }
    this.props.setSelectedFilter(null);
  }

  render() {
    const buttonsClassNames = ['dc-filter__bottom-buttons'];
    if (!this.props.noResults && this.state.isSticky) {
      buttonsClassNames.push('dc-filter__bottom-buttons--sticky');
    }

    if (this.props.pendingProductsRequest) {
      buttonsClassNames.push('dc-filter-bottom-buttons__loader');
    }

    return (
      <>
        {this.props.noResults && (
          <span className={'dc-filter__bottom-buttons--warning'}>
            <b>0 results</b>
            {' '}
            - Please remove some of your filters
          </span>
        )}
        {(this.props.xhrDisplayWarning && this.props.productsPostXhrError) && (
          <span className={'dc-filter__bottom-buttons--warning'}>
            {'Sorry, we can\'t apply filters just now. Please try later.'}
          </span>
        )}
        <div
          ref={this.bottomButtonsRef}
          className={buttonsClassNames.join(' ')}
        >
          <Button
            type={'reset'}
            disabled={this.props.disabled}
            onClick={this.onResetButtonClick}
          >
            {this.props.selectedFilter === null ? 'Reset filters' : 'Clear'}
          </Button>
          <Button
            type={'submit'}
            style={'checkout'}
            onClick={this.onSubmitButtonClick}
          >
            {this.props.selectedFilter === null ? 'Done' : 'Apply'}
          </Button>
        </div>
      </>
    );
  }
}

FiltersMobileButtons.displayName = 'FiltersMobileButtons';

FiltersMobileButtons.propTypes = {
  setSelectedFilter: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  selectedFilter: PropTypes.string,
  hideContainer: PropTypes.func,
  noResults: PropTypes.bool,
  resetAllFilters: PropTypes.func,
  resetFilterOptions: PropTypes.func,
  fetchListingPageData: PropTypes.func,
  toggleXhrErrorWarning: PropTypes.func,
  productsPostXhrError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  xhrDisplayWarning: PropTypes.bool,
  pendingProductsRequest: PropTypes.bool
};

FiltersMobileButtons.defaultProps = {
  setSelectedFilter: () => {},
  hideContainer: () => {},
  noResults: false,
  resetAllFilters: () => {},
  resetFilterOptions: () => {},
  toggleXhrErrorWarning: () => {},
  xhrDisplayWarning: false,
  fetchListingPageData,
  selectedFilter: null,
  productsPostXhrError: null,
  pendingProductsRequest: false
};

function mapStateToProps(state) {
  return {
    pendingProductsRequest: state.listingPage.pageSetup.xhrStatus.pendingProductsRequest,
    xhrDisplayWarning: state.listingPage.pageSetup.xhrStatus.xhrDisplayWarning
  };
}

const dispatchFunctions = {
  resetAllFilters, resetFilterOptions, fetchListingPageData, toggleXhrErrorWarning, isFilterActive
};

export default connect(mapStateToProps, dispatchFunctions)(FiltersMobileButtons);

